'use strict';

var sharedState = require('./sharedState');
const $cache = sharedState.$cache;

var commonFeatures = require('./commonFeatures');

const init = () => {
    // Handle travel dates
    $cache.tripDateStart.add($cache.tripDateEnd).on('click', (e) => {
        e.preventDefault();

        // Init Calendar
        if (!$cache.litepicker) {
            var minDate = new Date();
            minDate.setDate(minDate.getDate() - 1);

            const settings = $cache.mainWrapper.data('settings');

            const onSelectDate = (d1, d2) => {
                $cache.popupTravelDate.trigger('ita:selectDate', [d1, d2]);
            };

            const onApply = (d1, d2) => {
                $cache.popupTravelDate.trigger('ita:applyDates', [d1, d2]);
            }

            $cache.litepicker = new Litepicker({
                element: document.getElementById('litepicket-input'),
                autoRefresh: true,
                allowRepick: true,
                singleMode: commonFeatures.getCurrentTravelType() === 'oneway',
                autoApply: window.app.isMobile() ? false : true,
                minDate: minDate,
                setup: function(picker) {
                    picker.on('preselect', onSelectDate);
                    picker.on('button:apply', onApply);
                },
                lang: settings.locale.split('_')[0],
                showTooltip: false,
                parentEl: $('.popup-travel-date__calendar')[0],
                inlineMode: true,
                minDays: 1,
                numberOfMonths: window.app.isMobile() ? 1 : 2,
            });

            $cache.litepicker.show();
        } else {
            $cache.litepicker.clearSelection();
        }

        // Prepare popup
        $cache.travelDateApplyButton.prop('disabled', true);
        $cache.titleDateDeparture.show();
        $cache.titleDateReturn.hide();

        // Show popup
        $cache.popupTravelDate.addClass('visible');
    });

    // Close Travel date popup
    $cache.body.on('click', (e) => {
        // Popup is not visible, OR clicked element is detached
        if ($('.popup-travel-date.visible').length === 0 || !$.contains(document, e.target)) {
            return;
        }

        if ($(e.target).closest('.popup-travel-date, .award-search__trip-dates').length === 0) {
            $('.popup-travel-date').removeClass('visible');
        }
    });

    // Handle inner popup features
    handleDatesPopupBehavior();
};

const fillTripDates = (e, startDate, endDate) => {
    if (startDate) {
        let startDay = startDate.dateInstance.getDate();
        startDay = startDay >= 10 ? startDay + '' : '0' + startDay
        let startMonth = startDate.dateInstance.getMonth() + 1;
        startMonth = startMonth >= 10 ? startMonth + '' : '0' + startMonth;
        let startYear = startDate.dateInstance.getYear() + 1900;
        $cache.tripDateStart.attr('data-travel-date', JSON.stringify({date: `${startYear}-${startMonth}-${startDay}`}));
        fillDatesInput($cache.tripDateStart);
    } else {
        $cache.tripDateStart.val('');
        $cache.tripDateStart.removeAttr('data-travel-date');
    }

    if (endDate) {
        let endDay = endDate.dateInstance.getDate();
        endDay = endDay >= 10 ? endDay + '' : '0' + endDay
        let endMonth = endDate.dateInstance.getMonth() + 1;
        endMonth = endMonth >= 10 ? endMonth + '' : '0' + endMonth;
        let endYear = endDate.dateInstance.getYear() + 1900;
        $cache.tripDateEnd.attr('data-travel-date', JSON.stringify({date: `${endYear}-${endMonth}-${endDay}`}));
        fillDatesInput($cache.tripDateEnd);
    } else {
        $cache.tripDateEnd.val('');
        $cache.tripDateEnd.removeAttr('data-travel-date');
    }
};

const fillDatesInput = ($input) => {
    let travelDateData = null;
    try {
        travelDateData = JSON.parse($input.attr('data-travel-date'));
        if (travelDateData.date) {
            let tokens = travelDateData.date.split('-'); // [YYYY, MM, DD]
            // Format as DD/MM/YYYY
            $input.val(`${tokens[2]}/${tokens[1]}/${tokens[0]}`);
        }
    } catch (error) {
        // Nothing to do ...
        sharedState.debug('fillDatesInput', 'error', error);
    }
};

const handleDatesPopupBehavior = () => {
    // Handle click on dropout
    $cache.popupTravelDate.on('click', (e) => {
        if ($(e.target).hasClass('ita-popup')) {
            $cache.popupTravelDate.removeClass('visible');
        }
    });

    // Handle click on close button
    $cache.popupTravelDate.on('click', '.popup-travel-date__close', (e) => {
        $cache.popupTravelDate.removeClass('visible');
    });

    // Handle click on Apply button
    $cache.travelDateApplyButton.on('click', () => {
        // Apply dates
        $cache.popupTravelDate.find('.button-apply').trigger('click');
    });

    // Handle select date
    $cache.popupTravelDate.on('ita:selectDate', (e, startDate, endDate) => {
        sharedState.debug('ita:selectDate', 'startDate', startDate, 'endDate', endDate);
        const options = $cache.litepicker.options;
        // Enable Apply button
        let enableApplyButton = (startDate && options.singleMode) || (!options.singleMode && startDate && endDate);
        $cache.travelDateApplyButton.prop('disabled', !enableApplyButton);

        if (!options.singleMode && startDate && !endDate) {
            $cache.titleDateDeparture.hide();
            $cache.titleDateReturn.show();
        } else if (options.singleMode || !startDate) {
            $cache.titleDateDeparture.show();
            $cache.titleDateReturn.hide();
        }

        // On desktop, update on select
        if (!window.app.isMobile()) {
            fillTripDates(e, startDate, endDate);

            if (options.singleMode || endDate) {
                // Close popup
                $cache.popupTravelDate.removeClass('visible');

                // Check form validity
                $cache.mainWrapper.trigger('form:validityCheck');
            }
        }
    });

    // Handle Apply date
    $cache.popupTravelDate.on('ita:applyDates', (e, startDate, endDate) => {
        // Fill form
        fillTripDates(e, startDate, endDate);

        // Close popup
        $cache.popupTravelDate.removeClass('visible');

        // Check form validity
        $cache.mainWrapper.trigger('form:validityCheck');
    });
};

const checkInputsValidity = (skipInvalidate) => {
    let isDepartureDateValid = $cache.tripDateStart.val().length > 0;
    let isArrivalDateValid = $cache.tripDateEnd.val().length > 0;

    let isValid = isDepartureDateValid && (commonFeatures.getCurrentTravelType() === 'oneway' || isArrivalDateValid);

    if (isValid) {
        $cache.tripDatesWrapper.removeClass('invalid');
    } else if (!skipInvalidate) {
        $cache.tripDatesWrapper.addClass('invalid');
    }

    return isValid;
};


module.exports = {
    init: init,
    fillTripDates: fillTripDates,
    fillDatesInput: fillDatesInput,
    checkInputsValidity: checkInputsValidity,
};